import { defineMessages } from 'react-intl';

export const seoimageLinkMessages = defineMessages({
  label: {
    id: 'seoImageLink.label',
    defaultMessage: 'Bildquelle: {link}',
  },
});
